import React from 'react'
import { Loading } from '../Loading/Loading'

export interface DocumentPrintProps {
  documentPDF: string
  type?: 'base64'
}

export const DocumentPrint: React.FC<DocumentPrintProps> = ({
  documentPDF,
  type
}) => {
  if (documentPDF.length <= 0) {
    return <Loading />
  }

  return (
    <iframe
      style={{
        width: '100%',
        height: '720px',
        zoom: '0.8',
        MozTransformOrigin: '0 0',
        overflow: 'hidden'
      }}
      src={
        type === 'base64'
          ? `data:application/pdf;base64,${documentPDF}`
          : `${documentPDF}`
      }
      title='html-preview'
      allowFullScreen
      allowTransparency
      id='printViewer'
    >
      {documentPDF}
    </iframe>
  )
}
